export default __webpack_public_path__ + "static/card-image-3-6ee06fa0f4f9bb66bc8bbc08fd96acfe.jpg";